import { useLocale } from 'next-intl';
import { Locale } from '@headless-workspace/config';

export const useAppLocale = () => {
    return useLocale() as Locale;
};
